import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown, message, Tag } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ShopOutlined,
  TagOutlined,
  AppstoreOutlined,
  TruckOutlined,
  CloudServerOutlined,
  WalletOutlined,
  MessageOutlined,
  LinkOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { authAPI } from '../api';

// 添加蓝色主题样式
const blueMenuStyle = `
  .custom-blue-menu.ant-menu-light {
    background: transparent !important;
  }
  .custom-blue-menu.ant-menu-light .ant-menu-item {
    color: #314265 !important;
    background: transparent !important;
  }
  .custom-blue-menu.ant-menu-light .ant-menu-item:hover {
    background: rgba(37, 87, 255, 0.08) !important;
    color: #2557ff !important;
  }
  .custom-blue-menu.ant-menu-light .ant-menu-item-selected {
    background: #2557ff !important;
    color: white !important;
  }
  .custom-blue-menu.ant-menu-light .ant-menu-item-selected:after {
    border-right-color: #2557ff !important;
  }
  .custom-blue-menu.ant-menu-light .ant-menu-item-selected .anticon {
    color: white !important;
  }
`;

// 注入样式
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = blueMenuStyle;
  document.head.appendChild(styleElement);
}

const { Header, Sider, Content } = Layout;

const DropshipperLayout = ({ children, onLogout, selectedKey, onMenuSelect }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  // 根据当前路径确定选中的菜单项
  const getCurrentSelectedKey = () => {
    const path = location.pathname;
    // if (path.includes('/dashboard')) return 'dashboard';
    if (path.includes('/ch-products')) return 'ch-products';
    if (path.includes('/my-products') || path.includes('/add-to-store')) return 'my-products';
    if (path.includes('/manual-product-connect')) return 'manual-product-connect';
    if (path.includes('/my-customizations')) return 'my-customizations';
    if (path.includes('/support')) return 'support';
    if (path.includes('/freight')) return 'freight';
    if (path.includes('/my-stores') || path.includes('/connect-shopify')) return 'my-stores';
    if (path.includes('/orders') || path.includes('/create-order')) return 'orders';
    if (path.includes('/unmapped-orders')) return 'unmapped-orders';
    if (path.includes('/my-discounts')) return 'my-discounts';
    if (path.includes('/my-wallet')) return 'my-wallet';
    if (path.includes('/profile')) return 'profile';
    return selectedKey || 'ch-products';
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await authAPI.getProfile();
      setUserInfo(response.data);
    } catch (error) {
      message.error('Failed to get user info');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    onLogout();
    message.success('Logout successful');
  };

  const handleMenuClick = ({ key }) => {
    // 根据菜单key导航到对应路由
    switch (key) {
      // case 'dashboard':
      //   navigate('/dropshipper/dashboard');
      //   break;
      case 'ch-products':
        navigate('/dropshipper/ch-products');
        break;
      case 'my-products':
        navigate('/dropshipper/my-products');
        break;
      case 'manual-product-connect':
        navigate('/dropshipper/manual-product-connect');
        break;
      case 'my-customizations':
        navigate('/dropshipper/my-customizations');
        break;
      case 'support':
        navigate('/dropshipper/support');
        break;
      case 'freight':
        navigate('/dropshipper/freight');
        break;
      case 'my-stores':
        navigate('/dropshipper/my-stores');
        break;
      case 'orders':
        navigate('/dropshipper/orders');
        break;
      case 'unmapped-orders':
        navigate('/dropshipper/unmapped-orders');
        break;
      case 'my-wallet':
        navigate('/dropshipper/my-wallet');
        break;
      case 'my-discounts':
        navigate('/dropshipper/my-discounts');
        break;
      case 'profile':
        navigate('/dropshipper/profile');
        break;
      default:
        break;
    }
    // 同时调用原有的回调（如果存在）
    if (onMenuSelect) {
      onMenuSelect(key);
    }
  };

  const handleUserMenuClick = ({ key }) => {
    if (key === 'profile') {
      navigate('/dropshipper/profile');
    } else if (key === 'logout') {
      handleLogout();
    }
  };

  const userMenu = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: 'My Profile',
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Logout',
      },
    ],
    onClick: handleUserMenuClick,
  };

  const menuItems = [
    // {
    //   key: 'dashboard',
    //   icon: <DashboardOutlined />,
    //   label: 'Dashboard',
    // },
    {
      key: 'ch-products',
      icon: <AppstoreOutlined />,
      label: 'CH Products',
    },
    {
      key: 'my-products',
      icon: <ShopOutlined />,
      label: 'My Products',
    },
    {
      key: 'manual-product-connect',
      icon: <LinkOutlined />,
      label: 'Manual Connection',
    },
    {
      key: 'my-customizations',
      icon: <TagOutlined />,
      label: 'My Customizations',
    },
    {
      key: 'freight',
      icon: <TruckOutlined />,
      label: 'Freight',
    },
    {
      key: 'my-stores',
      icon: <CloudServerOutlined />,
      label: 'My Stores',
    },
    {
      key: 'orders',
      icon: <ShoppingCartOutlined />,
      label: 'My Orders',
    },
    {
      key: 'unmapped-orders',
      icon: <ExclamationCircleOutlined />,
      label: 'Unmapped Orders',
    },
    {
      key: 'my-wallet',
      icon: <WalletOutlined />,
      label: 'My Wallet',
    },
    {
      key: 'my-discounts',
      icon: <TagOutlined />,
      label: 'My Discounts',
    },
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'My Profile',
    },
    {
      key: 'support',
      icon: <MessageOutlined />,
      label: 'Support',
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', minWidth: '1024px' }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          background: 'linear-gradient(180deg, #f4f7ff 0%, #eef2ff 100%)',
          boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{
          height: 32,
          margin: 16,
          background: 'rgba(37, 87, 255, 0.12)',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#2557ff',
          fontWeight: 'bold',
          fontSize: collapsed ? '14px' : '16px',
          cursor: 'pointer'
        }}
        onClick={() => navigate('/')}
        >
          {collapsed ? 'CH' : 'CH Dropshipping'}
        </div>
        <Menu
          mode="inline"
          selectedKeys={[getCurrentSelectedKey()]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#314265'
          }}
          theme="light"
          className="custom-blue-menu"
        />
      </Sider>
      <Layout>
        <Header style={{
          padding: '0 16px',
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <Dropdown menu={userMenu} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
              <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>{userInfo?.username || 'Dropshipper'}</span>
              </div>
            </div>
          </Dropdown>
        </Header>
        <Content style={{
          margin: '16px',
          padding: '24px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default DropshipperLayout;
